var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chartOptions && _vm.hasData
    ? _c("VueApexChart", {
        ref: "chart",
        staticClass: "app-chart-range-bar",
        class: { live: _vm.autoUpdate },
        style: { height: _vm.chartHeight },
        attrs: { options: _vm.chartOptions, series: _vm.series }
      })
    : _c(
        "div",
        {
          staticClass: "app-chart-range-bar__empty",
          style: { height: _vm.chartHeight }
        },
        [_vm._v("\n\t" + _vm._s(_vm.noData) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3528b560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3528b560","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppChartRangeBar.vue
// module id = null
// module chunks = 